import script from "./ViewEmployeesAckStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEmployeesAckStatus.vue?vue&type=script&setup=true&lang=js"

import "./ViewEmployeesAckStatus.vue?vue&type=style&index=0&id=565a298d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565a298d"]])

export default __exports__